import { Fill, Stroke, Style, Text } from 'ol/style';
import { stringDivider } from '@/domain/textUtils';

export const toTextStyle = (text: string, zIndex: number) =>
  new Style({
    text: new Text({
      font: '11px "Buffon",sans-serif',
      overflow: true,
      fill: new Fill({ color: '#404040' }),
      stroke: new Stroke({ color: [255, 255, 255, 1], width: 3 }),
      text: stringDivider(text, 16, '\n'),
      textAlign: 'center',
      textBaseline: 'middle',
    }),
    zIndex,
  });
